// extracted by mini-css-extract-plugin
module.exports = {"section":"section-module--section--3P6n6","inner":"section-module--inner--2KwZ4","widen":"section-module--widen--1ATXy"};